/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const EYE_VIEWBOX_W = 15;
const EYE_VIEWBOX_H = 12.25;

const EYE_PATH =
  'M14.9426 5.7C13.4276 2.1825 10.5776 0 7.50261 0C4.42761 0 1.57761 2.1825 0.0626136 5.7C0.0213161 5.79462 0 5.89676 0 6C0 6.10324 0.0213161 6.20538 0.0626136 6.3C1.57761 9.8175 4.42761 12 7.50261 12C10.5776 12 13.4276 9.8175 14.9426 6.3C14.9839 6.20538 15.0052 6.10324 15.0052 6C15.0052 5.89676 14.9839 5.79462 14.9426 5.7V5.7ZM7.50261 10.5C5.12511 10.5 2.87511 8.7825 1.57761 6C2.87511 3.2175 5.12511 1.5 7.50261 1.5C9.88011 1.5 12.1301 3.2175 13.4276 6C12.1301 8.7825 9.88011 10.5 7.50261 10.5ZM7.50261 3C6.90927 3 6.32925 3.17595 5.8359 3.50559C5.34256 3.83524 4.95804 4.30377 4.73097 4.85195C4.50391 5.40013 4.4445 6.00333 4.56026 6.58527C4.67601 7.16721 4.96174 7.70176 5.38129 8.12132C5.80085 8.54088 6.3354 8.8266 6.91734 8.94236C7.49929 9.05811 8.10249 8.9987 8.65066 8.77164C9.19884 8.54458 9.66738 8.16006 9.99702 7.66671C10.3267 7.17336 10.5026 6.59334 10.5026 6C10.5026 5.20435 10.1865 4.44129 9.62393 3.87868C9.06132 3.31607 8.29826 3 7.50261 3V3ZM7.50261 7.5C7.20594 7.5 6.91593 7.41203 6.66926 7.2472C6.42258 7.08238 6.23033 6.84811 6.11679 6.57402C6.00326 6.29994 5.97356 5.99834 6.03144 5.70736C6.08931 5.41639 6.23217 5.14912 6.44195 4.93934C6.65173 4.72956 6.91901 4.5867 7.20998 4.52882C7.50095 4.47094 7.80255 4.50065 8.07664 4.61418C8.35073 4.72771 8.585 4.91997 8.74982 5.16664C8.91464 5.41332 9.00261 5.70333 9.00261 6C9.00261 6.39782 8.84458 6.77936 8.56327 7.06066C8.28197 7.34196 7.90044 7.5 7.50261 7.5Z';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Eye / visibility (15×12.25 viewBox). `size` sets rendered width; height scales to aspect ratio.
 * Color via `fill` (default `currentColor`). Pass `aria-label` when meaning isn’t clear from nearby text.
 */
const EyeIcon = ({
  className = '',
  size = 15,
  fill = 'currentColor',
  style,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  const { style: propsStyle, ...restProps } = props;
  const width = size;
  const height = (size * EYE_VIEWBOX_H) / EYE_VIEWBOX_W;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${EYE_VIEWBOX_W} ${EYE_VIEWBOX_H}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', 'ds-icon--filled', className].filter(Boolean).join(' ')}
      overflow="visible"
      style={{ display: 'block', ...propsStyle, ...style }}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...restProps}
    >
      <path d={EYE_PATH} fill={fill} />
    </svg>
  );
};

EyeIcon.propTypes = {
  ...iconPropTypes,
  /** Any valid SVG fill; default inherits text/icon color. */
  fill: PropTypes.string,
  style: PropTypes.shape({}),
};

export { EyeIcon };
export default EyeIcon;
